import React from "react";

const StripeIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2785_974)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 8,
  fill: "#635BFF"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.7467 16.1169C18.7467 15.2366 19.4735 14.898 20.6774 14.898C22.4036 14.898 24.5842 15.4171 26.3105 16.3426V11.0383C24.4252 10.2934 22.5626 10 20.6774 10C16.0664 10 13 12.3926 13 16.3877C13 22.6174 21.6314 21.6243 21.6314 24.3103C21.6314 25.3486 20.7228 25.6871 19.4508 25.6871C17.5655 25.6871 15.1578 24.9197 13.2499 23.8814V29.2534C15.3623 30.1563 17.4974 30.54 19.4508 30.54C24.1753 30.54 27.4235 28.2151 27.4235 24.1749C27.4007 17.4486 18.7467 18.6449 18.7467 16.1169Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2785_974"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(StripeIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;